import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import * as ChangeContact from 'assets/js/pages/contacts/single/timeline/timeline-list/change-contact';
import * as DropdownMenu from 'components/dropdown-menu';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentTransactionOrById } from 'customHooks/useCurrentTransactionOrById';
import { transactionQueryKeys } from 'queries/transaction-query-keys';

const ReassignTransaction = () => {
    const { accountId } = useCurrentAccount();
    const { data: transaction } = useCurrentTransactionOrById();
    const queryClient = useQueryClient();
    const { success } = useToast();

    if (!transaction?.contact) {
        return null;
    }
    return (
        <ChangeContact.Root
            activity={{
                source: 'system',
                type: 'transaction.succeeded',
                resource: {
                    id: transaction.id,
                },
            }}
            contact={transaction.contact}
            onSuccess={() => {
                success('Transaction reassigned successfully');
                queryClient.invalidateQueries({
                    queryKey: transactionQueryKeys.transactions(accountId),
                });
            }}
        >
            <ChangeContact.Trigger asChild>
                <DropdownMenu.Item onSelect={e => e.preventDefault()}>Reassign</DropdownMenu.Item>
            </ChangeContact.Trigger>
        </ChangeContact.Root>
    );
};

export { ReassignTransaction };
